import { req } from "./client.ts";

export type PortalEntry = { site: "internal" | "public"; internalSlug: string };

export const portalEntry = (signal?: AbortSignal): Promise<PortalEntry> => req<PortalEntry>("/api/portal/entry", { signal });
